import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from '../../hooks';
import { GoogleUtils, NavigationUtils } from '../../utils';
import { useCompanyStore, useAnswersStore } from '../../stores';
import { findAttendanceByToken } from '../../processes/attendance';

import ScheduledSucessfully from './ScheduledSucessfully';
import { showErrorToast } from '@amigoapp/doca-react';

function ScheduledSucessfullyContainer() {
	const query = useQuery();
	const history = useHistory();

	const { companySettings: { settings } } = useCompanyStore();

	const { answers } = useAnswersStore();

	const externalToken = useMemo(() => query.get('token'), [query]);

	const [attendance, setAttendance] = useState(null);
	const [attendanceStatus] = useState('CONFIRMED');

	const attendanceInfo = useMemo(() => ({
		start_date: attendance?.start_date || answers?.start_date,
		end_date: attendance?.end_date ||  answers?.end_date,
		user: attendance?.doctor ||  answers?.slot?.user,
		place: attendance?.place ||  answers?.slot?.place,
		event_group: attendance?.event_group ||  answers?.slot?.event_group,
		event: attendance?.event ||  answers?.slot?.event,
		allowedToEdit: !attendance?.done && !attendance?.confirmed_at && !attendance?.arrived && !attendance?.canceled && attendanceStatus === 'CONFIRMED',
		arrival_start_time: attendance?.arrival_start_time,
		arrival_end_time: attendance?.arrival_end_time,
		insurance: attendance?.insurance,
	}), [attendance, attendanceStatus, answers]);

	const [loading, setLoading] = useState(true);

	const googleCalendarUrl = useMemo(() => GoogleUtils.getCalendarUrl(attendanceInfo), [attendanceInfo]);
	const googleMapsDirectionUrl = useMemo(() => GoogleUtils.getDirectionUrl(answers?.place?.address), [answers?.place?.address]);

	const getAttendance = useCallback(async () => {
		const filter = { token: externalToken };

		if (!filter.token) {
			return;
		}

		setLoading(true);

		const { data, error } = await findAttendanceByToken(filter);

		if (error) {
			showErrorToast('Não foi possível buscar as informações do agendamento.');
		} else {
			setAttendance(data);
		}

		setLoading(false);
	}, [externalToken]);

	const handleDirectionPress = useCallback(() => {
		window.open(googleMapsDirectionUrl, '_blank');
	}, [googleMapsDirectionUrl]);

	useEffect(() => {
		getAttendance();
	}, [getAttendance, externalToken]);

	const handleAgendaPress = useCallback(() => {
		window.open(googleCalendarUrl, '_blank');
	}, [googleCalendarUrl]);

	const handleEditAttendancePress = () => NavigationUtils.navigate(history, `/update-timegrid/${externalToken}`);

	return (
		<ScheduledSucessfully
			loading={loading}
			attendance={attendanceInfo}
			settings={settings}
			attendanceStatus={attendanceStatus}
			googleCalendarUrl={googleCalendarUrl}
			googleMapsDirectionUrl={googleMapsDirectionUrl}
			handleEditAttendancePress={handleEditAttendancePress}
			variant={settings?.theme?.name}
			handleSaveAgendaPress={handleAgendaPress}
			handleDirectionPress={handleDirectionPress}
		/>
	);
}

export default ScheduledSucessfullyContainer;
